import {
  AccountBookOutlined,
  BarChartOutlined,
  BuildOutlined,
  CalendarOutlined,
  FileDoneOutlined,
  FileOutlined,
  FileProtectOutlined,
  PaperClipOutlined,
  ProfileOutlined,
  QuestionCircleOutlined,
  ShoppingCartOutlined,
  SolutionOutlined,
  SwapOutlined
} from "@ant-design/icons"
import { Select } from "antd"
import React from "react"

import {
  MANAGED_LIST_OPTION_ICONS,
  type ManagedListOptionIcon
} from "./list-options.types.ts"

// A fixed set, not a search over the whole @ant-design/icons library — the
// twelve names `ManagedListOption.Icon` accepts on the backend. Deliberately
// its own small map rather than importing Files' document-type-visuals.ts:
// Settings has no other dependency on the Files feature, and this picker
// works for any managed list a future `showIcon` caller might add, not only
// Document Type.
const ICON_COMPONENTS: Record<
  ManagedListOptionIcon,
  React.ComponentType<{ className?: string }>
> = {
  "file-protect": FileProtectOutlined,
  "file-done": FileDoneOutlined,
  "account-book": AccountBookOutlined,
  swap: SwapOutlined,
  build: BuildOutlined,
  "question-circle": QuestionCircleOutlined,
  profile: ProfileOutlined,
  "bar-chart": BarChartOutlined,
  "shopping-cart": ShoppingCartOutlined,
  calendar: CalendarOutlined,
  solution: SolutionOutlined,
  "paper-clip": PaperClipOutlined
}

export function iconPickerIcon(icon: string | undefined) {
  const Icon =
    (icon && ICON_COMPONENTS[icon as ManagedListOptionIcon]) || FileOutlined
  return <Icon className="text-secondary" />
}

interface IconPickerProps {
  value: ManagedListOptionIcon | ""
  onChange: (icon: ManagedListOptionIcon) => void
  disabled?: boolean
  ariaLabel: string
}

/** One icon per Document Type — a fixed picker, never free text or an
 *  upload, matching "use the existing icon system, no emoji." */
export function IconPicker({
  value,
  onChange,
  disabled,
  ariaLabel
}: IconPickerProps) {
  return (
    <Select<ManagedListOptionIcon>
      aria-label={ariaLabel}
      className="w-full"
      disabled={disabled}
      value={value || undefined}
      onChange={onChange}
      prefix={iconPickerIcon(value)}
      options={MANAGED_LIST_OPTION_ICONS.map((icon) => ({
        value: icon,
        label: icon
      }))}
      optionRender={(option) => (
        <span className="inline-flex items-center gap-1.5">
          {iconPickerIcon(
            option.data.value ? String(option.data.value) : undefined
          )}
          {option.data.label}
        </span>
      )}
    />
  )
}
